<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <router-link :to="{name: 'meters_list'}">
        <md-button class="md-info">
          <md-icon>arrow_back</md-icon>Back
        </md-button>
      </router-link>
    </div>

    <div class="md-layout-item md-size-100" v-if="!metersTestsList.length">
      <md-empty-state
        md-icon="filter_none"
        md-label="No stored load points"
        md-description="No stored meters load points in database"
      ></md-empty-state>
    </div>

    <!-- Load points list -->
    <div
      v-if="metersTestsList.length"
      class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-35 md-small-size-100 md-xsmall-size-100"
    >
      <md-list class="md-triple-line" style="margin: 30px 0;">
        <div v-for="item in metersTestsList" :key="item.ID">
          <md-list-item
            :class="[item.selected ? 'chatlist-selected' : '']"
            @click="selectMeasurement(item)"
          >
            <div class="md-list-item-text">
              <span>{{formatDateTime(item.timestamp)}}</span>
              <span>METER ERROR</span>
              <span>{{item.error}}</span>
            </div>
          </md-list-item>

          <md-divider />
        </div>
      </md-list>
    </div>

    <!-- Right section column 1 -->
    <div
      v-if="metersTestsList.length"
      class="md-layout-item md-xlarge-size-40 md-large-size-40 md-medium-size-65 md-small-size-100 md-xsmall-size-100"
    >
      <!-- Meter error -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Meter error</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="meterError" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell
                md-label="Value"
                md-numeric
                v-if="item.type === 'energy'"
              >{{getEnergyType(meterTestResult[item.value])}}</md-table-cell>
              <md-table-cell
                md-label="Value"
                md-numeric
                v-else-if="item.type === 'opsinput'"
              >{{getOPSInput(meterTestResult[item.value])}}</md-table-cell>
              <md-table-cell
                md-label="Value"
                md-numeric
                v-else
              >{{numberFormat(meterTestResult[item.value],item.decimals)}}</md-table-cell>
              <md-table-cell md-label md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>

      <!-- Basic Values -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Basic values</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="basicValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1" md-numeric>{{numberFormat(meterTestResult[item.L1],3)}}</md-table-cell>
              <md-table-cell md-label="L2" md-numeric>{{numberFormat(meterTestResult[item.L2],3)}}</md-table-cell>
              <md-table-cell md-label="L3" md-numeric>{{numberFormat(meterTestResult[item.L3],3)}}</md-table-cell>
              <md-table-cell md-label md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>

          <div class="footer_table_data">
            <h6 class="footer_element">Phase seq:</h6>
            <h6 class="footer_element_value">{{getPhaseSeq()}}</h6>
          </div>
          <div class="footer_table_data">
            <h6 class="footer_element">Connection:</h6>
            <h6 class="footer_element_value">{{getConectionType(meterTestResult.CONTYPE)}}</h6>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- Right section column 2 -->
    <div
      v-if="metersTestsList.length"
      class="md-layout-item md-xlarge-size-40 md-large-size-40 md-medium-size-65 md-small-size-100 md-xsmall-size-100 ml-auto"
    >
      <!-- Power values -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Power</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="powerValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1" md-numeric>{{numberFormat(meterTestResult[item.L1],3)}}</md-table-cell>
              <md-table-cell md-label="L2" md-numeric>{{numberFormat(meterTestResult[item.L2],3)}}</md-table-cell>
              <md-table-cell md-label="L3" md-numeric>{{numberFormat(meterTestResult[item.L3],3)}}</md-table-cell>
              <md-table-cell md-label md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>

      <!-- Energy values -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Energy</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="energyValues" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Value">{{ item.value }}</md-table-cell>
              <md-table-cell md-label="L1" md-numeric>{{numberFormat(meterTestResult[item.L1],2)}}</md-table-cell>
              <md-table-cell md-label="L2" md-numeric>{{numberFormat(meterTestResult[item.L2],2)}}</md-table-cell>
              <md-table-cell md-label="L3" md-numeric>{{numberFormat(meterTestResult[item.L3],2)}}</md-table-cell>
              <md-table-cell md-label md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>

      <!-- Maximum Demand -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Maximum Demand</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-model="maximumDemand" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
              <md-table-cell
                md-label
                md-numeric
                v-if="item.type != 'ts'"
              >{{numberFormat(meterTestResult[item.value],item.decimals)}}</md-table-cell>
              <md-table-cell
                md-label="Value"
                md-numeric
                v-else
              >{{formatDateTime(meterTestResult[item.value])}}</md-table-cell>
              <md-table-cell md-label md-numeric>{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import TabsOriginal from "@/components/TabsOriginal";
import format from "date-fns/format";

import axios from "axios";
import Swal from "sweetalert2";

import {
  MeterError,
  BasicValues,
  PowerValues,
  EnergyValues,
  MaximumDemand
} from "./MeterErrorDataTypes";

export default {
  components: {
    Tabs: TabsOriginal,
    graphToolBar,
    snackBar
  },

  data() {
    return {
      metersTestsList: [],
      metersTestsResults: [],
      testItemsList: [],
      meterTestResult: {},
      basicValues: BasicValues,
      powerValues: PowerValues,
      meterError: MeterError,
      energyValues: EnergyValues,
      maximumDemand: MaximumDemand
    };
  },

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  mounted() {
    this.getTestResults();
  },

  methods: {
    selectMeasurement(measurement) {
      this.metersTestsList.map(el => (el.selected = false));
      measurement.selected = true;

      const findedIndex = this.metersTestsResults.findIndex(
        el => el.IDN === measurement.ID
      );

      if (findedIndex !== -1) {
        this.meterTestResult = this.metersTestsResults[findedIndex];
      }
    },

    getPhaseSeq() {
      let data = [
        { name: "1", value: this.meterTestResult.MPHA1 },
        { name: "2", value: this.meterTestResult.MPHA2 },
        { name: "3", value: this.meterTestResult.MPHA3 }
      ];
      data.sort((a, b) => {
        if (a.value > b.value) {
          return 1;
        }
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });

      return "L" + data[0].name + data[1].name + data[2].name;
    },

    getConectionType(connection_ID) {
      const data = ["3P4W", "3P3W", "2P3W", "1P3W", "1P2W"];
      return data[connection_ID];
    },

    getEnergyType(ID) {
      const data = ["Active", "Reactive", "Apparent"];
      return data[ID];
    },

    getOPSInput(ID) {
      const data = ["LED", "DISC/SO", "SNAP. S"];
      return data[ID];
    },

    getTestResults(ID_meter) {
      this.$store.commit("setLoading", true);
      this.metersTestsList = [];
      this.metersTestsResults = [];
      this.testItemsList = [];

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applied-precision/test-result",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          ID_meter: Number(this.$route.params.meter_id)
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.forEach(el => {
            this.metersTestsList.push({
              ID: el.IDN,
              timestamp: el.MTIME,
              error: el.ERROR.toFixed(2) + "%",
              selected: false
            });
            let obj = Object.assign({}, el);
            obj.Z_L1 = Number(el.MCHNLA1) / Number(el.MCHNLB1);
            obj.Z_L2 = Number(el.MCHNLA2) / Number(el.MCHNLB2);
            obj.Z_L3 = Number(el.MCHNLA3) / Number(el.MCHNLB3);

            obj.SINPH1 = Number(el.MQPOWER1) / Number(el.MSPOWER1);
            obj.SINPH2 = Number(el.MQPOWER1) / Number(el.MSPOWER2);
            obj.SINPH3 = Number(el.MQPOWER1) / Number(el.MSPOWER3);

            obj.Iq_L1 =
              (Number(el.MCHNLB1) * Number(el.MQPOWER1)) / Number(el.MSPOWER1);
            obj.Iq_L2 =
              (Number(el.MCHNLB2) * Number(el.MQPOWER2)) / Number(el.MSPOWER2);
            obj.Iq_L3 =
              (Number(el.MCHNLB3) * Number(el.MQPOWER3)) / Number(el.MSPOWER3);

            obj.Ip_L1 = Number(el.MPOWFACT1) * Number(el.MCHNLB1);
            obj.Ip_L2 = Number(el.MPOWFACT2) * Number(el.MCHNLB2);
            obj.Ip_L3 = Number(el.MPOWFACT3) * Number(el.MCHNLB3);

            this.metersTestsResults.push(obj);
          });

          //Sorting newest first
          this.metersTestsList.sort((a, b) => {
            if (a.timestamp < b.timestamp) {
              return 1;
            }
            if (a.timestamp > b.timestamp) {
              return -1;
            }
            return 0;
          });

          this.testItemsList = Object.keys(this.metersTestsResults[0]);
          this.selectMeasurement(this.metersTestsList[0]);

          this.$store.commit("setLoading", false);
        })
        .catch(error => {
          this.$store.commit("setLoading", false);
          if (error.response) {
            if (error.response.data.code !== 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    formatDateTime(ts) {
      return format(ts * 1000, "DD.MM.YYYY HH:mm:ss");
    },

    numberFormat(value, decimals = 3) {
      if (value == null) {
        return "";
      }
      return `${Number(value).toFixed(decimals)}`;
    }
  }
};
</script>


<style lang="scss" scoped>
.chatlist-selected {
  background-color: #d3d0d0;
}

.footer_table_data {
  display: flex;
  flex-wrap: wrap;
}

.footer_element {
  margin: 10px 0px 10px 0px;
  flex-grow: 1.5;
  width: 10%;
}

.footer_element_value {
  margin: 10px 0px 10px 0px;
  flex-grow: 4;
}
</style>
